// extracted by mini-css-extract-plugin
export default {"disableScroll":"J2Chlj","wrapper":"xe_upa","overlay":"u8eZUB","modal":"Kuud12","head":"HediAe","title":"xRlKaY","closeButton":"RrDqyX"};